import NewsCard from "./NewsCard";

const Home = () => {
  return (
    <>
      <div className="container-fluid jumbotron jumbotron-image py-5">
        <div className="container">
          <h1 className="display-3 fw-bold text-white">Acasă</h1>
        </div>
      </div>
      <div className="container">
        <nav aria-label="breadcrumb" className="mb-3 mt-4 ms-3">
          <ol className="breadcrumb">
            <li className="breadcrumb-item active" aria-current="page">
              Acasă
            </li>
          </ol>
        </nav>
        <div className="container history">
          <div className="row">
            <div className="col-lg-9">
              <h2 className="mb-4">Despre noi</h2>
              <div className="p-4 bg-light rounded">
                <p>
                  ASOCIAȚIA ONCOHEM CLUJ-NAPOCA a fost înființată de către
                  medici hematologi si oncologi în 2023, cu principalul scop de
                  a facilita educația medicală continuă în rândul medicilor
                  hematologi si oncologi, promovând în același timp și
                  importanța abordării multidisciplinare a bolilor
                  onco-hematologice. Astfel, ne-am propus să organizăm
                  manifestări științifice cu participare multidisciplinară,
                  facilitând colaborarea dintre medicii implicați în
                  diagnosticarea și tratarea pacienților cu boli hematologice și
                  oncologice. Deasemenea, fiind o organizație non-profit, ne-am
                  propus să oferim consultație virtuală gratuită celor care
                  doresc o opinie de specialitate sau a doua părere.
                </p>
                <h4 className="mb-3">Membri fondatori</h4>
                <p>
                  Dr. Anca Simona Bojan, medic primar hematolog în cadrul IOCN
                  și profesor unversitar la Catedra de Hematologie al UMF Cluj
                </p>
                <p>
                  Dr. Török-Vistai Tünde, medic primar hematolog în cadrul IOCN
                  și sef lucrări la Catedra de Hematologie al UMF Cluj
                </p>
                <p>Dr. Anca Vasilache, medic primar hematolog în cadrul IOCN</p>
                <p>
                  Dr. Ramona Matei, medic primar oncolog la Spitalul Clinic
                  Municipal Cluj-Napoca
                </p>
                <p className="mb-1">
                  Dr. Dinu Bolunduț, medic rezident oncologie în cadrul IOCN
                </p>
              </div>
            </div>
            <div className="col-lg-3">
              <h2 className="pb-3">Noutăți</h2>
              <div className="row">
                <div className="col">
                  <NewsCard
                    image="images/3.jpg"
                    title="Simpozion #3"
                    date="29 noiembrie 2025, ora 08:30"
                    link="three"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
